<script setup lang="ts">
import { ref } from 'vue'
import { useUserInfoStore } from '~/stores/useUserInfo'
import { useCityInfoStore } from '~/stores/useCityInfo'
import { getHeadMenuList } from '~/server/newhouse'

defineProps({
  hasLogin: {
    type: Boolean,
    default: true,
  },
  container: {
    type: Boolean,
    default: true,
  },
})

interface tab {
  title: string
  url: string
}

const { city } = useCityInfoStore()
const switching = ref<tab[]>([
  // 首页、新房、二手房、租房、装修、资讯、知识、问答
  // {
  //   title: '首页',
  //   url: '/',
  // },
  // {
  //   title: '新房',
  //   url: '/newhouse/',
  // },
  // {
  //   title: '二手房',
  //   url: '/second/',
  // },
  // {
  //   title: '租房',
  //   url: '/rent/',
  // },
  // {
  //   title: '装修',
  //   url: '/home/',
  // },
  // {
  //   title: '资讯',
  //   url: '/news/',
  // },
  // {
  //   title: '知识',
  //   url: 'https://www.fccs.com/wiki/',
  // },
  // {
  //   title: '问答',
  //   url: `https://www.fccs.com/wenda/${shortDomain ? `${shortDomain}/` : ''}`,
  // },
])
getHeadMenuList({ cityId: city }).then((res) => {
  const { code, dataBody } = res
  if (code === 0) {
    switching.value = dataBody.map((item: any) => {
      return {
        title: item.name,
        url: item.menuurl,
      }
    })
  }
})

const showLogin = ref(false)
const userStore = useUserInfoStore()
const { cityName } = useCityInfoStore()

function toLogin() {
  window.location.href = `https://member.fccs.com/login.jhtml?forwardUrl=${encodeURIComponent(window.location.href)}`
}
</script>

<template>
  <div class="bg-modules">
    <div :class="`${container ? 'container' : ''} switching`">
      <div class="modules-ul">
        <div>
          <a class="modules-li" href="//www.fccs.com">{{ cityName }} <CaretDownOutlined class="relative top-0.1" /></a>
        </div>
        <div v-for="(item, index) in switching" :key="index">
          <a class="modules-li" :href="item.url">{{ item.title }}</a>
        </div>
        <ClientOnly>
          <div v-if="hasLogin" class="login-bottom">
            <div v-if="!userStore.userInfo" class="login-info">
              <span class="cursor-pointer" @click="toLogin()">登录</span>
              <a-divider type="vertical" style="background-color: #8B8A8A;" />
              <span class="cursor-pointer" @click="() => {}">注册</span>
            </div>
            <div v-else class="login-info">
              <a class="cursor-pointer" href="https://member.fccs.com/person/index.jhtml" target="_blank">{{ userStore.userInfo.username || '房超会员' }}</a>
              <a-divider type="vertical" style="background-color: #8B8A8A;" />
              <span class="cursor-pointer" @click="userStore.clearUserInfo()">退出</span>
            </div>
            <!--          加入FCCS的链接跳转 -->
            <NuxtLink to="https://jm.fccs.com/" class="join">
              <FlagFilled /> 加入FCCS
            </NuxtLink>
          </div>
        </ClientOnly>
      </div>
    </div>
  </div>
  <login-modal v-model:showLogin="showLogin" @close="showLogin = false" />
</template>

<style scoped lang="scss">
a {
  &:hover {
    color: unset;
  }
}
.bg-modules {
  background: #303035;
  font-size: 14px;

  .switching {
    .modules-ul {
      display: flex;
      grid-column-gap: 30px;
      height: 40px;
      line-height: 38px;

      .modules-li {
        font-weight: normal;
        color: #ffffff;
      }
      .login-bottom {
        margin-left: auto;
        color: #8B8A8A;
        display: flex;
        grid-column-gap: 12px;

        .login-info {
          height: 40px;
          line-height: 40px;

          a {
            color: #8B8A8A;
          }
        }

        .join {
          height: 24px;
          line-height: 24px;
          margin-top: 8px;
          background: #FE5302;
          font-size: 14px;
          color: #FFFFFF;
          padding: 0px 15px;
          box-sizing: border-box;
          border-radius: 23px;
        }
      }
    }
  }
}
</style>
